import { Routes } from '@angular/router';
import { checkTutorialGuard } from './providers/check-tutorial.guard';
import { AuthGuard } from './providers/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/app/tabs/tasks',
    pathMatch: 'full',
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./pages/forgot-password/forgot-password').then(m => m.ForgotPasswordPage),
  },
  {
    path: 'app',
    loadChildren: () =>
      import('./pages/tabs-page/routes').then(m => m.TABS_ROUTES),
    canActivate: [AuthGuard],
  },
  {
    path: 'tutorial',
    loadComponent: () =>
      import('./pages/tutorial/tutorial').then(m => m.TutorialPage),
    canMatch: [checkTutorialGuard],
  },
  { path: '**', redirectTo: '/' },
];
